import { Radio } from '@ovotech/nebula';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import { ButtonContainer } from './Form.styled';

type Props = {
  label: string;
  name: string;
  value: string;
  dataTestId?: string;
};

const RadioButton = ({ label, name, value, dataTestId }: Props) => {
  const id = uuidv4();
  const { register } = useFormContext();

  return (
    <ButtonContainer data-testid={dataTestId}>
      <Radio
        data-testid={`${name}${value}`}
        id={id}
        value={value}
        type="radio"
        label={label}
        {...register(name)}
      />
    </ButtonContainer>
  );
};

export default RadioButton;
